import { render, staticRenderFns } from "./ScreenPagec.vue?vue&type=template&id=d6934908&scoped=true"
import script from "./ScreenPagec.vue?vue&type=script&lang=js"
export * from "./ScreenPagec.vue?vue&type=script&lang=js"
import style0 from "./ScreenPagec.vue?vue&type=style&index=0&id=d6934908&prod&lang=less&scoped=true"
import style1 from "./ScreenPagec.vue?vue&type=style&index=1&id=d6934908&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6934908",
  null
  
)

export default component.exports